import { FlaskConical } from "lucide-react";

const EduTestingAppsTileDesign = {
  id: "edu-testing-apps",
  icon: FlaskConical,
  label: "EDU Testing Apps",
  background: "#4f46e5",
  color: "#ffffff",
};

export default EduTestingAppsTileDesign;
